import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { AppStore } from '../store/store';
import { MerchantState } from '../store/merchant.slice';
import { UserState } from '../store/user.slice';
import { isMultiMerchantView } from './roles';

export interface ActiveMerchantFilters<F> {
    effectiveFilters: F;
    canFetch: boolean;
    isMultiMerchantView: boolean;
    selectedMerchantId?: string;
}

export const useActiveMerchantFilters = <F extends Record<string, any>>(filters: F): ActiveMerchantFilters<F> => {
    const { user } = useSelector<AppStore, UserState>((state) => state.user);
    const { selectedMerchantId } = useSelector<AppStore, MerchantState>((state) => state.merchant);

    return useMemo(() => {
        const multi = isMultiMerchantView(user?.roles);
        if (!multi) {
            return {
                effectiveFilters: filters,
                canFetch: true,
                isMultiMerchantView: false,
                selectedMerchantId,
            };
        }
        return {
            effectiveFilters: { ...filters, merchantId: selectedMerchantId } as F,
            canFetch: !!selectedMerchantId,
            isMultiMerchantView: true,
            selectedMerchantId,
        };
    }, [filters, selectedMerchantId, user?.roles]);
};
